import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Utils
import { initMetaMaskHandler } from './utils/metamaskHandler';

// Components
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './layouts/MainLayout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserDetails from './pages/UserDetails';
import Deposits from './pages/Deposits';
import Withdrawals from './pages/Withdrawals';
import Salary from './pages/Salary';

// Placeholder components for remaining pages
const Rewards = () => <div className="page-placeholder"><h2>Rewards Panel</h2><p>Coming Soon...</p></div>;
const Transactions = () => <div className="page-placeholder"><h2>Transactions</h2><p>Coming Soon...</p></div>;
const Reports = () => <div className="page-placeholder"><h2>Reports</h2><p>Coming Soon...</p></div>;
const Settings = () => <div className="page-placeholder"><h2>Settings</h2><p>Coming Soon...</p></div>;
const Register = () => <div className="page-placeholder"><h2>Register</h2><p>Coming Soon...</p></div>;

function App() {
  useEffect(() => {
    // Initialize MetaMask error handler
    initMetaMaskHandler();

    // Check for saved theme preference
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      document.body.classList.add('dark-mode');
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="users/:userId" element={<UserDetails />} />
            <Route path="deposits" element={<Deposits />} />
            <Route path="withdrawals" element={<Withdrawals />} />
            <Route path="salary" element={<Salary />} />
            <Route path="rewards" element={<Rewards />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Router>
  );
}

export default App;